import { makeStyles } from '@material-ui/core';
import { useOperator } from '../../contexts/OperatorContext';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { getFromLS, saveToLS } from '../../lib/localStorageHelpers';
import React, { useState } from 'react';
import { useDashboardCards } from './useDashboardCards';
import { NoDataMessage } from '../../components/NoDataMessage';
import { useUser } from '../../contexts/UserContext';

const ResponsiveGridLayout = WidthProvider(Responsive);

interface Props {
  lockLayout: boolean;
  theme: string[];
}

export const DashboardLayout = (props: Props) => {
  const { lockLayout, theme } = props;

  const operator = useOperator();
  const user = useUser();
  const savedLayout = getFromLS('tangerine-layouts', 'dashboardLayout') || {};
  const [layouts, setLayouts] = useState(savedLayout);

  const onLayoutChange = (layout: any, layouts: any) => {
    saveToLS('tangerine-layouts', 'dashboardLayout', layouts);
    setLayouts(layouts);
  };

  const cards = useDashboardCards(
    user.permissions,
    operator?.id ?? 0,
    operator?.systems.map((s) => s.name) ?? [],
    operator?.type ?? null,
    theme
  ).filter((c: any) => c.permission);

  const classes = useStyles();

  return cards.length > 0 ? (
    <ResponsiveGridLayout
      className={classes.layout}
      cols={{ lg: 4, md: 3, sm: 2, xs: 1, xxs: 1 }}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      rowHeight={132}
      margin={[30, 30]}
      layouts={layouts}
      isDraggable={!lockLayout}
      isResizable={!lockLayout}
      onLayoutChange={(layout: any, layouts: any) =>
        onLayoutChange(layout, layouts)
      }
      preventCollision={false}
    >
      {cards.map((card, index) => {
        return (
          <div
            key={card.id}
            data-grid={{
              ...card.defaultSize.size,
              x: index % 4,
              y: 0,
              ...card.defaultSize.minSize,
            }}
          >
            {card.component}
          </div>
        );
      })}
    </ResponsiveGridLayout>
  ) : (
    <NoDataMessage title="No Cards To Display" />
  );
};

const useStyles = makeStyles((theme) => ({
  layout: {
    '&:active .react-grid-item.react-grid-placeholder': {
      backgroundColor: '#FFFF',
      borderStyle: 'dashed',
      borderWidth: 3,
    },
    '&:active .react-grid-item.react-draggable-dragging': {
      boxShadow: '-10px 21px 19px -4px rgba(0,0,0,0.24)',
      cursor: 'grabbing',
    },
  },
}));
